module.exports = __webpack_public_path__ + "static/img/t39.0ef4970e.png";